<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="dg-module-container text-capitalize mb-2" v-if="formHeader">
      <h5>{{ this.getFormTitle }}</h5>
    </div>

    <div class="dg-module-container p-3">
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['voip-vendor-api'].dropdownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Suppliers"
            name="voip_supplier_id"
            placeholder=""
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['voip-destination-api'].dropDownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Destination"
            name="destination_id"
            placeholder=""
            rules="required"></dg-select-field>
      </el-col>


      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['voip-rate-division-api'].dropDownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Division"
            name="division_id"
            placeholder=""
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="optional"
            label="Rate"
            name="rate"
            placeholder="0.04"
            rules="optional"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 10">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="optional"
            label="Note"
            name="note"
            type="textarea"
            placeholder=""
            rules="optional"></dg-text-field>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{ (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria') }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="moduleDeleteAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                     :translate="false"
                     :type="actionButtonType" fieldSize="mini"
                     v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import module from './../index.js'
import {mapState, mapActions} from 'vuex'
import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  beforeMount() {this.getFormData()},
  data() {
    return {
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      radioOptions: [
        {
          label: 'Online',
          value: 'on',
          link_label: ''
        },
        {
          label: 'Offline',
          value: 'off',
          link_label: ''
        }
      ],
    }
  },
  methods: {
    ...$mapActions('voip-vendor-api', {
      getSuppliersDropdown: 'getDropDownList',
    }),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropDownList: 'getDropDownList',
    }),
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    getFormData() {
      let promises = []
      promises.push(this.getEntityDropDownList().then())
      promises.push(this.getDestinationsDropDownList().then())
      promises.push(this.getSuppliersDropdown().then())
      promises.push(this.getDivisionsDropDownList().then())
      Promise.all(promises).then((values) => {
        this.amReady = true
        Vue.nextTick(() => {this.bindController()})
      })
    },
    ...mapActions('voip-suppliers-offered-list-api', {
      getEntityDropDownList: 'getDropDownList',
      updateImage: 'updateImage',
      updateGallery: 'updateGallery',
      removeGalleryImage: 'removeGalleryImage'
    }),
    /* Images Methods */
    removeFromGallery (file) {
      let params = {
        id: this.dataToBind.id,
        fileId: file.id,
        parentId: file.parent_id
      }
      this.removeGalleryImage(params).then(r => {
        if (this.onEditCallback) {
          this.onEditCallback(r.data, 'gallery', false)
        }
        notifySuccess('Picture Removed')
      })
    },
    async uploadMainPicture (entityId) {
      if (this.dataModel.hasOwnProperty('picture') && this.dataModel.picture) {
        let pictureParams = {
          data: {picture: this.dataModel.picture},
          id: entityId
        }
        await this.updateImage(pictureParams).then(r => {
          notifySuccess('Picture Uploaded')
        }).catch(error => {
          notifyDanger('Picture Not Uploaded')
        })
      }
    },
    async uploadGallery (entityId) {
      if (this.dataModel.hasOwnProperty('gallery') && this.dataModel.gallery) {
        let galleryParams = {
          data: {
            gallery: this.dataModel.gallery
          },
          id: entityId
        }

        await this.updateGallery(galleryParams).then(r => {
          notifySuccess('Gallery Uploaded')
        }).catch(error => {
          notifyDanger('Gallery Not Uploaded')
        })
      }
    },
    async createModule() {
      this.validateFields().then( async result => {
        if (!result) { this.requestErrorMessage = null; return}

        this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;


        /* Images Handleing */
          // removing files they are handled alone
          delete apiParams.data.picture
          delete apiParams.data.gallery

          if (apiMethod == 'update') {
            await this.uploadMainPicture(this.dataToBind.id) // Updating Picture
            await this.uploadGallery(this.dataToBind.id) // Updating Gallery
          }

        this.$store.dispatch('voip-suppliers-offered-list-api/' + apiMethod, apiParams).then(response => {
          let entity = response.data
          this.amReady = false
          notifySuccess((apiMethod == 'update')? 'Updated' : 'Created')

          if (apiMethod == 'create') {
            this.uploadMainPicture(entity.id) // Updating Picture
            this.uploadGallery(entity.id) // Updating Gallery
          }

          Vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          console.log('catch error', error)
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {this.requestOn = false})
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
